import { Navigate } from 'react-router-dom';
import { AuthSideBanner } from '@/components/auth/auth-side-banner';
import { PageMeta } from '@/components/page-meta';
import { IS_COMMUNITY_SELF_HOSTED } from '@/config';
import { ROUTES } from '@/utils/routes';
import { SelfHostedInvitationAccept } from '@/utils/self-hosted/invitation-accept';

/**
 * `/auth/invitation/:token` — the invitation URL the community API mails out. Clerk and better-auth
 * handle invitations through their own hosted flows, so this page only serves the self-hosted build.
 */
export function InvitationTokenAcceptPage() {
  if (!IS_COMMUNITY_SELF_HOSTED) {
    return <Navigate to={ROUTES.INVITATION_ACCEPT} replace />;
  }

  return (
    <div className="flex min-h-screen w-full flex-col md:max-w-[1100px] md:flex-row md:gap-36">
      <PageMeta title="Accept Invitation" />
      <div className="w-full md:w-auto">
        <AuthSideBanner />
      </div>
      <div className="flex flex-1 justify-end px-4 py-8 md:items-center md:px-0 md:py-0">
        <div className="flex w-full max-w-[500px] flex-col items-start justify-start">
          <SelfHostedInvitationAccept />
        </div>
      </div>
    </div>
  );
}
